export const required = (value: any) => (!value ? 'REQUIRED' : undefined);
